import React from 'react';
import './inventoryParamCurrentStatusCard.css';


interface InventoryParameCurrentStatusCardProps {
    componentData:  IInventoryParamComponent | null
}

const getComponentLabel = (componentData: IInventoryParamComponent | null) => {
    const prefix = componentData?.component?.toUpperCase();
    let suffix = '';

    if(componentData?.connector) {
        suffix = ` - CONNECTOR ${componentData?.connector}`
    }

    else if (componentData?.smrUnitNo != null) {
        suffix = ` - UNIT ${componentData?.smrUnitNo}`
    }
    return prefix + suffix;
}

const isEmptyValue = (value: string | null | undefined): boolean =>
  value === null || value === undefined || value.trim() === '' || value.trim() === '-' || value.trim().toLowerCase() === 'na';

const InventoryParamCurrentStatusCard: React.FC<InventoryParameCurrentStatusCardProps> = ({componentData}: InventoryParameCurrentStatusCardProps) => {
  
  return (
    <div className='inventory__param__current__status__card'>
        <div className='inventory__param__current__status__card-header'>
            <div className='inventory__param__current__status__card-header-component-label'>
                {componentData ? getComponentLabel(componentData) : '-'}
            </div>
            <div className='inventory__param__current__status__card-header-right'>
                CURRENT STATUS
            </div>
        </div>

        <div className='inventory__param__current__status__card-body'>
            {
                componentData?.parameters?.map(( parameter, index ) => {
                    return <>
                        <div className='inventory__param__current__status__card-param-container'>
                            <div className='inventory__param__current__status__card-param-label'>{parameter?.visibleName}</div>
                            <div className='inventory__param__current__status__card-param-value'>{isEmptyValue(parameter?.value) ? '-' : parameter?.value}</div>
                        </div>

                        {
                            index < componentData?.parameters.length - 1 && <div className='inventory__param__current__status__card-param-container-separator'></div>
                        }
                    </>
                } )
            }
        </div>
        
    </div>
  )
}

export default InventoryParamCurrentStatusCard